import { isAfter, isBefore, isEqual } from "date-fns";
import { enToFaDigits, faToEnDigits } from "jb-core";

//#region web-component/jb-date-input/module/lib/constants.ts
const emptyInputValueString = "    /  /  ";
/**
* format of your input date strings. it effects value, min & max or other value that provides in string type to the component.
*/
const inputFormat = "YYYY/MM/DD";
const inputRegex = /^(?<year>[\u06F0-\u06F90-9,\s]{4})\/(?<month>[\u06F0-\u06F90-9,\s]{2})\/(?<day>[\u06F0-\u06F90-9,\s]{2})$/g;

//#endregion
//#region web-component/jb-date-input/module/lib/types.ts
var InputTypes;
(function(InputTypes$1) {
	InputTypes$1["jalali"] = "JALALI";
	InputTypes$1["gregorian"] = "GREGORIAN";
})(InputTypes || (InputTypes = {}));

//#endregion
//#region web-component/jb-date-input/module/lib/index.ts
function isLeapYearJalali(year) {
	const matches = [
		1,
		5,
		9,
		13,
		17,
		22,
		26,
		30
	];
	const modulus = year % 33;
	return matches.includes(modulus);
}
function getEmptyValueObject() {
	return {
		gregorian: {
			year: null,
			month: null,
			day: null
		},
		jalali: {
			year: null,
			month: null,
			day: null
		},
		timeStamp: null,
		time: {
			hour: null,
			minute: null,
			second: null,
			millisecond: null
		}
	};
}
function getMonth(value) {
	return value.substring(5, 7);
}
function getYear(value) {
	return value.substring(0, 4);
}
function getDay(value) {
	return value.substring(8, 10);
}
/**
* tell you that given caret pos is belonging to each part of web-component
*/
function getSelectionPart(caretPos) {
	if (caretPos < 5) return "YEAR";
	if (caretPos < 8) return "MONTH";
	if (caretPos < 11) return "DAY";
	return null;
}
function handleDayBeforeInput(inputType, typedNumber, caretPos, value, inputChar) {
	let isIgnoreChar = false;
	if (caretPos == 8 && typedNumber > 3) {
		inputChar("0", caretPos);
		caretPos++;
	}
	if (caretPos == 9 && typedNumber > 1 && value[8] == "3") isIgnoreChar = true;
	if (caretPos == 9 && typedNumber == 0 && value[8] == "0") isIgnoreChar = true;
	if (caretPos == 8 && typedNumber == 0 && value[9] == "0") isIgnoreChar = true;
	if (inputType == "JALALI" && !isIgnoreChar) {
		const month = getMonth(value);
		const monthNumber = Number(month);
		if (caretPos == 9 && value[8] == "3" && typedNumber > 0 && monthNumber > 6) isIgnoreChar = true;
		if (caretPos == 8 && typedNumber == 3) {
			if (monthNumber == 12) {
				const yearNumber = Number(getYear(value));
				const isLeapYear = Number.isNaN(yearNumber) ? false : isLeapYearJalali(yearNumber);
				if (!isLeapYear) isIgnoreChar = true;
			}
			if (value[9] > "0") {
				if (month.length == 2 && parseInt(value) > 6) inputChar("0", 9);
				if (month.length == 2 && monthNumber < 7 && value[9] > "1") inputChar("1", 9);
			}
		}
	}
	return {
		isIgnoreChar,
		caretPos
	};
}
function handleMonthBeforeInput(inputValue, typedNumber, caretPos) {
	let isIgnoreChar = false;
	if (caretPos == 5 && typedNumber == 1 && inputValue[6] > "2") isIgnoreChar = true;
	if (caretPos == 6 && typedNumber > 2 && inputValue[5] == "1") isIgnoreChar = true;
	if (caretPos == 6 && typedNumber == 0 && inputValue[5] == "0") isIgnoreChar = true;
	if (caretPos == 5 && typedNumber == 0 && inputValue[4] == "0") isIgnoreChar = true;
	return {
		isIgnoreChar,
		caretPos
	};
}
function checkMinValidation(date, minDate) {
	const minValid = isAfter(date, minDate) || isEqual(date, minDate);
	return minValid;
}
function checkMaxValidation(date, maxDate) {
	const minValid = isBefore(date, maxDate) || isEqual(date, maxDate);
	return minValid;
}
function isValidChar(char) {
	return /[\u06F0-\u06F90-9/]/g.test(char);
}
function standardString(dateString) {
	const sNumString = faToEnDigits(dateString);
	const sString = sNumString.replace(/[^\u06F0-\u06F90-9/]/g, "");
	return sString;
}
/**
* will input and replace a certain char in the given string
*/
function replaceChar(char, pos, currentValue, showPersianNumber) {
	if (pos == 4 || pos == 7) char = "/";
	if (pos > 9 || pos < 0) return currentValue;
	const newValueArr = currentValue.split("");
	if (showPersianNumber) char = enToFaDigits(char);
	newValueArr[pos] = char;
	const newValue = newValueArr.join("");
	return newValue;
}
function handleBeforeInput(params) {
	const { showPersianNumber, dateInputType, selection, event: { data, inputType } } = params;
	const baseCaretPos = selection.start;
	let finalCaretPos = baseCaretPos;
	let finalValue = params.value;
	if (data) handleInsert();
	if (inputType == "deleteContentBackward" || inputType == "deleteContentForward" || inputType == "delete" || inputType == "deleteByCut" || inputType == "deleteByDrag") handleDelete(inputType, selection.start, selection.end, inputChar, setSelectionRange);
	return {
		value: finalValue,
		selectionStart: finalCaretPos,
		selectionEnd: finalCaretPos
	};
	function inputChar(char, pos) {
		finalValue = replaceChar(char, pos, finalValue, showPersianNumber);
	}
	function setSelectionRange(caretPosition) {
		finalCaretPos = caretPosition;
	}
	function handleInsert() {
		const StdString = standardString(params.event.data || "");
		StdString.split("").forEach((inputtedChar, i) => {
			let caretPos = baseCaretPos + i;
			if (!isValidChar(inputtedChar)) return;
			if (caretPos == 4 || caretPos == 7) {
				if (inputtedChar == "/") setSelectionRange(caretPos + 1);
				caretPos++;
			}
			let isIgnoreChar = false;
			if (inputtedChar == "/") return;
			const typedNumber = Number(inputtedChar);
			if (caretPos == 5 && typedNumber > 1) {
				inputChar("0", caretPos);
				caretPos++;
			}
			const monthRes = handleMonthBeforeInput(finalValue, typedNumber, caretPos);
			caretPos = monthRes.caretPos;
			const dayRes = handleDayBeforeInput(dateInputType, typedNumber, caretPos, finalValue, inputChar);
			caretPos = dayRes.caretPos;
			isIgnoreChar = isIgnoreChar || dayRes.isIgnoreChar || monthRes.isIgnoreChar;
			if (!isIgnoreChar) {
				inputChar(inputtedChar, caretPos);
				setSelectionRange(caretPos + 1);
			}
		});
	}
}
function handleDelete(inputEventType, selectionStart, selectionEnd, inputChar, setSelectionRange) {
	let d = 0;
	if (inputEventType == "deleteContentBackward") d = selectionStart !== selectionEnd ? 0 : -1;
	for (let i = selectionStart; i <= selectionEnd; i++) inputChar(" ", i + d);
	setSelectionRange(selectionStart + d);
}
/**
* return best caret pos base on current input caret pos (move caret pos to last empty char of each section)
*/
function getFixedCaretPos(params) {
	const caretPos = params.selectionStart;
	if (caretPos) {
		const trimmedYearLength = getYear(params.inputValue).trim().length;
		const trimmedMonthLength = getMonth(params.inputValue).trim().length;
		const trimmedDayLength = getDay(params.inputValue).trim().length;
		if (trimmedYearLength < caretPos && (caretPos <= 4 || trimmedMonthLength == 0 && trimmedDayLength == 0)) return trimmedYearLength;
		if (caretPos > 4 && (caretPos <= 7 && trimmedMonthLength + 5 < caretPos || trimmedDayLength == 0 && trimmedMonthLength < 2)) return trimmedMonthLength + 5;
		if (trimmedDayLength + 8 < caretPos && caretPos > 7 && caretPos <= 10) return trimmedDayLength + 8;
	}
	return null;
}

//#endregion
export { InputTypes, checkMaxValidation, checkMinValidation, emptyInputValueString, getDay, getEmptyValueObject, getFixedCaretPos, getMonth, getSelectionPart, getYear, handleBeforeInput, handleDayBeforeInput, handleMonthBeforeInput, inputFormat, inputRegex, isLeapYearJalali, isValidChar, replaceChar, standardString };
//# sourceMappingURL=index.js.map